import React from 'react';
import { InputType } from '../Form/InputType';
import { RowType } from '../Form/RowType';
import { Translate } from '@above-the-treeline/localization';

export const getInitialFormValuesById = userAttributes => {
	const dataKeyByInputId = {
		uriPersonal: 'Personal Website Uri',
		uriFacebook: 'Facebook Uri',
		uriTwitter: 'Twitter Uri',
		uriLinkedIn: 'LinkedIn Uri',
		uriGoodreads: 'Goodreads Uri',
		uriSkype: 'Skype Uri',
		uriInstagram: 'Instagram Uri',
		uriTikTok: 'TikTok Uri',
		uriBluesky: 'Bluesky Uri',
		uriYouTube: 'YouTube Uri',
		uriStoryGraph: 'StoryGraph Uri',
		uriThreads: 'Threads Uri',
	};

	let initialFormValuesById = {};

	for (const inputId in dataKeyByInputId) {
		const dataKey = dataKeyByInputId[inputId];

		initialFormValuesById[inputId] =
			userAttributes && userAttributes[dataKey]
				? userAttributes[dataKey].Value
				: '';
	}

	return initialFormValuesById;
};

export const getRowOptionsList = () => {
	const rowOptionsList = [
		getSocialMediaLinkRowOptions(
			<Translate id="blog_personal" />,
			'uriPersonal',
			'icon-ios-body',
		),
		getSocialMediaLinkRowOptions(
			'Facebook',
			'uriFacebook',
			'icon-facebook-icon',
		),
		getSocialMediaLinkRowOptions('X', 'uriTwitter', 'icon-x-logo'),
		getSocialMediaLinkRowOptions(
			'LinkedIn',
			'uriLinkedIn',
			'icon-linkedin-alt',
		),
		getSocialMediaLinkRowOptions(
			'Goodreads',
			'uriGoodreads',
			'icon-goodreads',
		),
		getSocialMediaLinkRowOptions(
			'Instagram',
			'uriInstagram',
			'icon-instagram',
		),
		getSocialMediaLinkRowOptions('TikTok', 'uriTikTok', 'icon-tiktok'),
		getSocialMediaLinkRowOptions('Bluesky', 'uriBluesky', 'icon-bluesky'),
		getSocialMediaLinkRowOptions('YouTube', 'uriYouTube', 'icon-youtube'),
		getSocialMediaLinkRowOptions(
			'StoryGraph',
			'uriStoryGraph',
			'icon-storygraph',
		),
		getSocialMediaLinkRowOptions('Threads', 'uriThreads', 'icon-threads'),
	];

	return rowOptionsList;
};

const getSocialMediaLinkRowOptions = (label, inputId, iconCssClass) => {
	return {
		rowType: RowType.SocialMediaLinkInputRow,
		rowTypeData: {
			label: label,
			inputId: inputId,
			inputType: InputType.TextInput,
			iconCssClass: iconCssClass,
		},
	};
};
